import { Box, Paper } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';
import { periverseTheme } from '@peritasai/ui-shared';
import type { PropsWithChildren, ReactNode } from 'react';
import { ViewAllToggle } from './ViewAllToggle';

export type ListCardProps = PropsWithChildren<{
  sx?: SxProps<Theme>;
  showViewAll: boolean;
  expanded: boolean;
  onToggleViewAll: () => void;
  viewAllLabel: ReactNode;
}>;

const baseListCardSx = {
  width: { xs: '680px', md: '100%' },
  maxWidth: { xs: 680, md: '100%' },
  display: 'flex',
  flexDirection: 'column',
  alignItems: { xs: 'center', md: 'stretch' },
  gap: { xs: '16px', md: '16px' },
  borderRadius: '24px',
  border: `1px solid ${periverseTheme.palette.divider}`,
  background: periverseTheme.palette.background.paper,
  boxShadow: '0 1px 8px 0 rgba(0, 0, 0, 0.08)',
  padding: { xs: '40px 32px', md: '16px' },
} satisfies SxProps<Theme>;

export const ListCard = ({
  children,
  sx,
  showViewAll,
  expanded,
  onToggleViewAll,
  viewAllLabel,
}: ListCardProps) => (
  <Box
    sx={{
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: { xs: 'center', md: 'stretch' },
      justifyContent: { xs: 'center', md: 'flex-start' },
    }}
  >
    <Paper sx={{ ...baseListCardSx, ...sx }}>
      {children}
      <ViewAllToggle
        visible={showViewAll}
        expanded={expanded}
        onClick={onToggleViewAll}
      >
        {viewAllLabel}
      </ViewAllToggle>
    </Paper>
  </Box>
);

export default ListCard;
